
export const checkAndroidApp = () => {
    return navigator.userAgent.search("pmkino-webapp-android")
}

export const checkWebApp = (isAndroidApp) => {
    const isiOSApp = navigator.userAgent.search("iOS WebApp")
  
    return isAndroidApp !== -1 || isiOSApp !== -1

}

export const checkPmkinoWebApp = (isAndroidApp) => {
  const isiOSApp = navigator.userAgent.search("pmkino-webapp-ios")

  return isAndroidApp !== -1 || isiOSApp !== -1
};